import { faDatabase } from '@fortawesome/pro-regular-svg-icons';
import React, { useState } from 'react';
import { GoogleAdsRequestTypeGq } from '../../../../../graphql/projects/models/GoogleAdsRequestTypeGq';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import { VoxelPopover } from '../../../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../voxel/Popover/VoxelPopoverTrigger';
import VoxelMenuDivider from '../../../../voxel/PopoverMenu/VoxelMenuDivider';
import VoxelMenuHeader from '../../../../voxel/PopoverMenu/VoxelMenuHeader';
import VoxelMenuItemContainer from '../../../../voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelPopoverMenuItem from '../../../../voxel/PopoverMenu/VoxelPopoverMenuItem';
import VoxelTooltipShort from '../../../../voxel/Tooltip/VoxelTooltipShort';
import InfoIcon from '../../../../voxel/Icons/InfoIcon';
import AddBasicKeywordsForm from './AddKeywords/AddBasicKeywords/AddBasicKeywordsForm';
import { SearchRequestTypes } from './AddKeywords/AddBasicKeywords/logic/SearchModels';
import AddComboKeywordsDialog from './AddKeywords/AddComboKeywords/AddComboKeywordsDialog';
import { CurrentUserGq } from '../../../../../graphql/users/models/CurrentUserGq';

export interface AddKeywordsButtonProps {
  project: ProjectGq;
  user: CurrentUserGq;
  reload: () => Promise<unknown>;
}

export const AddKeywordsButton: React.FC<AddKeywordsButtonProps> = ({ project, reload, user }) => {
  const [basicType, setBasicType] = useState<GoogleAdsRequestTypeGq>(undefined);
  const [openCombo, setOpenCombo] = useState(false);
  return (
    <>
      {!!basicType && (
        <AddBasicKeywordsForm
          project={project}
          reload={reload}
          type={basicType}
          handleClose={() => setBasicType(undefined)}
          user={user}
        />
      )}
      {openCombo && (
        <AddComboKeywordsDialog
          project={project}
          handleClose={() => setOpenCombo(false)}
          reload={reload}
        />
      )}
      <VoxelPopover>
        <VoxelPopoverTrigger enableActive>
          <DataTableToolbarButton
            label="Add keywords"
            effect={!project.progressKeywordCount ? 'success' : undefined}
            tooltip="Add keywords to the project"
            iconProp={faDatabase}
          />
        </VoxelPopoverTrigger>
        <VoxelPopoverContent className="w-72">
          <VoxelMenuItemContainer size="sm">
            <VoxelPopoverMenuItem
              title={
                SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.EXACT)?.name
              }
              onClick={() => setBasicType(GoogleAdsRequestTypeGq.EXACT)}
              keyboardShortcut={
                <VoxelTooltipShort
                  message={
                    SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.EXACT)
                      ?.shortDescription
                  }
                  placement="right"
                >
                  <InfoIcon />
                </VoxelTooltipShort>
              }
            />
            <VoxelMenuDivider />
            <VoxelMenuHeader>Google Ads suggestions</VoxelMenuHeader>
            <VoxelPopoverMenuItem
              title={
                SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.RELATED)?.name
              }
              onClick={() => setBasicType(GoogleAdsRequestTypeGq.RELATED)}
              keyboardShortcut={
                <VoxelTooltipShort
                  message={
                    SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.RELATED)
                      ?.shortDescription
                  }
                  placement="right"
                >
                  <InfoIcon />
                </VoxelTooltipShort>
              }
            />
            <VoxelPopoverMenuItem
              title={SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.URL)?.name}
              onClick={() => setBasicType(GoogleAdsRequestTypeGq.URL)}
              keyboardShortcut={
                <VoxelTooltipShort
                  message={
                    SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.URL)
                      ?.shortDescription
                  }
                  placement="right"
                >
                  <InfoIcon />
                </VoxelTooltipShort>
              }
            />
            <VoxelPopoverMenuItem
              title={SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.SITE)?.name}
              onClick={() => setBasicType(GoogleAdsRequestTypeGq.SITE)}
              keyboardShortcut={
                <VoxelTooltipShort
                  message={
                    SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.SITE)
                      ?.shortDescription
                  }
                  placement="right"
                >
                  <InfoIcon />
                </VoxelTooltipShort>
              }
            />
            <VoxelMenuDivider />
            <VoxelMenuHeader>Advanced</VoxelMenuHeader>
            <VoxelPopoverMenuItem
              title={
                SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.LONG_TAIL)?.name
              }
              onClick={() => setBasicType(GoogleAdsRequestTypeGq.LONG_TAIL)}
              keyboardShortcut={
                <VoxelTooltipShort
                  message={
                    SearchRequestTypes.find((sr) => sr.type === GoogleAdsRequestTypeGq.LONG_TAIL)
                      ?.shortDescription
                  }
                  placement="right"
                >
                  <InfoIcon />
                </VoxelTooltipShort>
              }
            />
            <VoxelPopoverMenuItem
              title={SearchRequestTypes.find((sr) => sr.type === 'COMBO')?.name}
              onClick={() => setOpenCombo(true)}
              keyboardShortcut={
                <VoxelTooltipShort
                  message={SearchRequestTypes.find((sr) => sr.type === 'COMBO')?.shortDescription}
                  placement="right"
                >
                  <InfoIcon />
                </VoxelTooltipShort>
              }
            />
          </VoxelMenuItemContainer>
        </VoxelPopoverContent>
      </VoxelPopover>
    </>
  );
};

export default AddKeywordsButton;
